export default {
  title: "Документтер",
  instruction: "Инструкциялар",
};
